import { makeStyles } from 'tss-react/mui';

const name = 'ConnectionSnippet';

export const useConnectionSnippetStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),

    borderRadius: theme.shape.borderRadiusXl,

    backgroundColor: theme.palette.background.paper,
  },
}));
